import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import update from 'immutability-helper';
import { apis, apiHolder as api } from 'api';
const MailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const getItemStyle = (isDragging, draggableStyle) => (Object.assign({ userSelect: 'none', background: 'white' }, draggableStyle));
const ClassifyList = ({ dataList, setDataList, renderItem, _account }) => {
    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const startIndex = result.source.index;
        const endIndex = result.destination.index;
        const items = update(dataList, {
            $splice: [
                [startIndex, 1],
                [endIndex, 0, dataList[startIndex]],
            ],
        });
        MailConfApi.sortMailClassifyRule(+result.draggableId, dataList.length - 1 - endIndex, _account);
        setDataList(items);
    };
    return (React.createElement(DragDropContext, { onDragEnd: onDragEnd },
        React.createElement(Droppable, { droppableId: "droppable-1", type: "PERSON" }, (provided, snapshotDrop) => (React.createElement("div", Object.assign({ ref: provided.innerRef }, provided.droppableProps),
            dataList.map((item, index) => (React.createElement(Draggable, { draggableId: item.id + '', index: index, key: item.id }, (provided, snapshot) => (React.createElement("div", Object.assign({ ref: provided.innerRef }, provided.dragHandleProps, provided.draggableProps, { style: Object.assign({}, getItemStyle(snapshot.isDragging, provided.draggableProps.style)) }), renderItem(item, index)))))),
            snapshotDrop.isDraggingOver && React.createElement("div", { style: { height: '200px' } }))))));
};
export default ClassifyList;
